import CoinIcon from "./CoinIcon";

export default CoinIcon;
export { CoinIcon };
